const movies = [
  {
    title: 'Kingsglaive',
    subtitle: 'Final Fantasy XV',
    storyline: 'King Regis, who oversees the land of Lucis, commands his army of soldiers to protect the kingdom from the Niflheim empire\'s plans to steal the sacred crystal.',
    rating: 4.5,
    imagePath: 'images/Kingsglaive_Final_Fantasy_XV.jpg',
  },
  {
    title: 'Final Fantasy',
    subtitle: 'Spirits Within',
    storyline: 'A scientist makes a last stand on Earth with the help of a ragtag team of soldiers against an invasion of alien phantoms.',
    rating: 4.5,
    imagePath: 'images/Final_Fantasy_Spirits_Within.jpg',
  },
  {
    title: 'Ghost In The Shell',
    subtitle: 'Ghost In The Shell',
    storyline: 'A hacker known as the Puppet Master is hunted by a female cyborg cop and her partner. This film is a revised version of Ghost in the Shell (1995).',
    rating: 5,
    imagePath: 'images/Ghost_In_The_Shell_2_0.jpg',
  },
  {
    title: 'Appleseed Alpha',
    subtitle: 'Appleseed Alpha',
    storyline: 'A young female soldier Deunan and her cyborg partner Briareos survive through the post World War 3 apocalyptic New York in search of human\'s future hope, the legendary city of Olympus.',
    rating: 3.8,
    imagePath: 'images/Appleseed_Alpha.jpg',
  },
  {
    title: 'Resident Evil',
    subtitle: 'Vendetta',
    storyline: 'Chris Redfield enlists the help of Leon S. Kennedy and Rebecca Chambers to stop a death merchant, with a vengeance, from spreading a deadly virus in New York.',
    rating: 4.2,
    imagePath: 'images/Resident_Evil_Vendetta.jpg',
  },
];

export default movies;
